import axios from "axios";
import { API_URL } from "../constant";

const API_BASE_URL = API_URL || "https://staging.api.topcoinuk.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const captainTcCardService = {
  getAllAssignments: async () => {
    const response = await api.get("/superadmin/captain-tc-cards");
    return response.data;
  },

  generateCards: async (data) => {
    const response = await api.post("/superadmin/captain-tc-cards/generate", data);
    return response.data;
  },

  getAvailablePrefixes: async () => {
    const response = await api.get("/superadmin/captain-tc-cards/available-prefixes");
    return response.data;
  },

  getUnassignedCards: async (prefix = "") => {
    const url = prefix ? `/superadmin/captain-tc-cards/unassigned?prefix=${prefix}` : `/superadmin/captain-tc-cards/unassigned`;
    const response = await api.get(url);
    return response.data;
  },

  getCardsByBatch: async (batchTime = "") => {
    const url = batchTime ? `/superadmin/captain-tc-cards/cards-by-batch?batch_time=${batchTime}` : `/superadmin/captain-tc-cards/cards-by-batch`;
    const response = await api.get(url);
    return response.data;
  },

  getAvailableBundles: async () => {
    const response = await api.get("/superadmin/captain-tc-cards/available-bundles");
    return response.data;
  },

  getBatchRecords: async (id) => {
    const response = await api.get(`/superadmin/captain-tc-cards/${id}/records`);
    return response.data;
  },

  assignCards: async (data) => {
    const response = await api.post("/superadmin/captain-tc-cards/assign", data);
    return response.data;
  },

  updateAssignment: async (id, data) => {
    const response = await api.put(`/superadmin/captain-tc-cards/${id}`, data);
    return response.data;
  },

  deleteAssignment: async (id) => {
    const response = await api.delete(`/superadmin/captain-tc-cards/${id}`);
    return response.data;
  }
};
